import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { PageHero } from "@/components/PageHero";
import { Workshops } from "@/components/Workshops";
import { WeeklyTimetable } from "@/components/WeeklyTimetable";
import { RelatedLinks } from "@/components/RelatedLinks";
import { usePageMeta } from "@/hooks/usePageMeta";
import { SITE } from "@/data/site";
import { Calendar } from "lucide-react";

export default function WorkshopsPage() {
  usePageMeta(
    "Monthly Workshops & Community Gatherings",
    "Cultural workshops, social dance nights and community gatherings — Salsa, Bachata, Kizomba, Zouk, Kompa, Afro Socials and Open Cyphers across London & Kent."
  );
  return (
    <>
      <Header />
      <main>
        <PageHero
          overline="02 · Monthly Workshops & Community Gatherings"
          title="After dark."
          highlight="On the floor."
          description="Monthly cultural workshops, social dance nights and community gatherings — designed to bring people together through movement, music and culture. Many sessions take place at bars, clubs, cultural spaces and community events. Some are offered free or donation-based."
          ctaPrimary={{ label: "Reserve a workshop", to: "/workshops#reserve" }}
          ctaSecondary={{ label: "See events", to: "/events" }}
          bg={SITE.socialImg1}
        />
        <Workshops />

        {/* Workshop timetable + reserve flow */}
        <section id="reserve" data-testid="workshops-timetable-section" className="relative py-20 sm:py-24 bg-black scroll-mt-24 overflow-hidden">
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute top-0 right-1/4 w-[500px] h-[500px] rounded-full bg-brand-purpleDeep/20 blur-3xl" />
          </div>
          <div className="relative max-w-6xl mx-auto px-6 sm:px-8">
            <div className="flex items-center gap-3 mb-5">
              <Calendar size={16} className="text-brand-yellow" />
              <span className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.3em] text-brand-yellow">
                Upcoming Workshops
              </span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl text-white tracking-wide leading-[0.95] mb-8">
              Reserve a <span className="text-brand-yellow text-glow-yellow">spot</span>.
            </h2>
            <WeeklyTimetable variant="compact" defaultFilter="workshop" />
          </div>
        </section>

        <RelatedLinks
          title="Related"
          items={[
            { tag: "Battles", label: "Events & Battles", desc: "Cyphers, comps and showcases", to: "/events" },
            { tag: "Adults", label: "Weekly Training", desc: "Structured classes every week", to: "/training" },
            { tag: "B2B", label: "Bespoke Workshops", desc: "Book for your team or venue", to: "/schools-organisations" },
          ]}
        />
      </main>
      <Footer />
    </>
  );
}
